/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbound_Outcome_No_DiscrepancyInputs */

const en_inbound_outcome_no_discrepancy = /** @type {(inputs: Inbound_Outcome_No_DiscrepancyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Received as declared`)
};

/**
* | output |
* | --- |
* | "Received as declared" |
*
* @param {Inbound_Outcome_No_DiscrepancyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_outcome_no_discrepancy = /** @type {((inputs?: Inbound_Outcome_No_DiscrepancyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Outcome_No_DiscrepancyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_outcome_no_discrepancy(inputs)
});